import type { LockPosition } from "@/types";

interface MockState {
    balances: {
        USDC: string;
        IUSD: string;
        SIUSD: string;
    };
    approvals: Record<string, number>;
    lockPositions: LockPosition[];
    lastRewardUpdate: number;
}

declare global {
    interface Window {
        demoState: MockState;
    }
}

const window = globalThis as unknown as Window;

const initializeMockState = () => {
    if (!window.demoState) {
        window.demoState = {
            balances: {
                USDC: "1000000",
                IUSD: "0",
                SIUSD: "0",
            },
            approvals: {},
            lockPositions: [],
            lastRewardUpdate: Date.now(),
        };
    }
    return window.demoState;
};

export const getMockState = (): MockState => {
    return window.demoState;
};

// Initialize state when module loads
initializeMockState();
